import { LockedError, InvalidCredentialsError, InvalidCountryError, UnprocessableEntityError, GeneralUnknownError } from './errors.js';

/**
 * @name normalizeGraphQlError
 * This function normalizes combined GraphQl Errors
 * @param {object} error combinedError
 * @returns error
 */

function normalizeGraphQlError(error) {
  if (error) {
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      var _error$graphQLErrors$, _error$graphQLErrors$2, _error$graphQLErrors$3, _body$errors, _body$errors$base, _error$graphQLErrors$4, _error$graphQLErrors$5, _error$graphQLErrors$6, _body$errors2, _body$errors2$country;

      var body = (_error$graphQLErrors$ = error.graphQLErrors[0]) === null || _error$graphQLErrors$ === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors$.extensions) === null || _error$graphQLErrors$2 === void 0 ? void 0 : (_error$graphQLErrors$3 = _error$graphQLErrors$2.response) === null || _error$graphQLErrors$3 === void 0 ? void 0 : _error$graphQLErrors$3.body;
      var base = (body === null || body === void 0 ? void 0 : (_body$errors = body.errors) === null || _body$errors === void 0 ? void 0 : (_body$errors$base = _body$errors.base) === null || _body$errors$base === void 0 ? void 0 : _body$errors$base[0]) || {};
      var status = (_error$graphQLErrors$4 = error.graphQLErrors[0]) === null || _error$graphQLErrors$4 === void 0 ? void 0 : (_error$graphQLErrors$5 = _error$graphQLErrors$4.extensions) === null || _error$graphQLErrors$5 === void 0 ? void 0 : (_error$graphQLErrors$6 = _error$graphQLErrors$5.response) === null || _error$graphQLErrors$6 === void 0 ? void 0 : _error$graphQLErrors$6.status;
      /** Player is locked cases */

      if (base.errorCode && base.errorCode === "locked") {
        return new LockedError(base.reason, base.expiresAt);
      }
      /** Invalid credentials case */


      if (base.error && base.error === "Invalid Credentials") {
        return new InvalidCredentialsError(status);
      }
      /* The country is locked for registration */


      if (body !== null && body !== void 0 && (_body$errors2 = body.errors) !== null && _body$errors2 !== void 0 && (_body$errors2$country = _body$errors2.countryCode) !== null && _body$errors2$country !== void 0 && _body$errors2$country.includes("invalid-country")) {
        return new InvalidCountryError();
      }
      /* Unprocessable entity. One or several registration fields have incorrect format or value */


      if (status === 422) {
        return new UnprocessableEntityError(body.errors, status);
      }
      /** General unknow case */


      return new GeneralUnknownError(status);
    }

    if (error.networkError) {
      return new Error("[Network error]: request has failed");
    }
  }
}

export { normalizeGraphQlError };
